export default __webpack_public_path__ + "static/media/add.571fd663.svg";